"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m22 10-6-6H2v16h20zm-7-4.5 5.5 5.5H15z"
}), 'NoteSharp');